import React, { Component } from 'react';
import '../styles/BookList.css';
import Book from './Book';

class BookList extends Component {

  renderBooks = () => {
    let books = this.props.books;
    if (books.length > 0) {
      return books.map((book) => {
        if (book.volumeInfo.title.length > 50 || book.volumeInfo.authors.length > 2) return null;
        if (/free|download|sample|bundle|series|box|book 2|book two|book 3|book three|book four|book 4|book five|book 5/.test(book.volumeInfo.title.toLowerCase())) return null; 
        if (book.volumeInfo.imageLinks) return <Book book={book} key={book.id} selectBook={this.props.selectBook}/>;
        else return null;
      })
    } else {
      return null;
    }
  }

  render () {
    return(
      <div className='BookList'>
        {this.renderBooks()}
      </div>
    )
  }
}

export default BookList;



// WEBPACK FOOTER //
// ./src/components/BookList.js